import React, { useContext, useEffect, useState } from 'react';
import StatBox from "../components/StatBox";
import '../styles/pages/home.scss';
import Map from "../components/Map";
import StrainPhylotree from "../components/StrainPhylotree";
import icon1 from '../assets/images/icn-dna.png'
import icon2 from '../assets/images/icn-gene-family.png'
import icon3 from '../assets/images/icn-virulence.png'
import icon4 from '../assets/images/icn-antibiotic-resist.png'
// import { useCookies } from 'react-cookie';
import fetchOptionsBuilder from '../fetchOptionBuilder';
import WorkflowContext from '../workflowContext';


function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

export default function Home(props) {
    const [statData, setStatData] = useState(null);
    const [dataStatus, setDataStatus] = useState('Loading');
    const workflow = useContext(WorkflowContext);
    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const [userfname,setUserFullName] = useState("");

    const [apitoken, setApitoken] = useState(        // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));

    useEffect(() => {
        const name = localStorage.getItem('usernameDisplay');
        if(name){
            setUserFullName(localStorage.getItem('usernameDisplay'))

        }
        // fetch data from the API on page load
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + "summary/json", fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(response => response.json())
            .then(data =>  {
                console.log('data', data);
                if (data.error) {
                    setDataStatus('Error');
                } else {
                    setStatData(data);
                    setDataStatus('Success');
                }
            })
    }, [workflow, apitoken, getDataUserId]);

    useEffect(() => {
        document.title = `Palmona Pathogenomics`
    }, []);

    return (
        <div className="screen home">
            <div className="container mt-4 text-secondary">
                <div className="row">
                    <div className="col-6">
                        <h1>Welcome, {userfname}</h1>
                        <hr/>
                        {dataStatus === 'Success' && <h2>Reports Overview</h2>}
                    </div>
                </div>
                {dataStatus === 'Success' && <div className="row">
                    {statData.strains > 1 &&
                    <div className="col-3" id="home-box">
                        <StatBox
                            title="Strains"
                            icon={icon1}
                            number={statData ? statData.strains : ''}
                            linkTo="strains"
                            linkText="Overview"/>
                    </div>}
                    {statData.clusters > 1 &&
                        <div className="col-3" id="home-box">
                        <StatBox
                            title="Gene Families"
                            icon={icon2}
                            number={statData ? statData.clusters : ''}
                            linkTo="gene-families"
                            linkText="Overview"/>
                    </div>}
                    {statData.samples > 1 &&
                        <div className="col-3" id="home-box">
                        <StatBox
                            title="QC'd Samples"
                            icon={icon1}
                            number={statData ? statData.samples : ''}
                            linkTo="multiqc"
                            linkText="Overview"/>
                    </div>}
                    {statData.virulence > 0 &&
                    <div className="col-3" id="home-box">
                        <StatBox
                            title="Virulence Factors"
                            icon={icon3}
                            number={statData ? statData.virulence : ''}
                            linkTo="virulence"
                            linkText="Overview"/>
                    </div>}
                    {statData.resistance > 0 &&
                    <div className="col-3" id="home-box">
                        <StatBox
                            title="Antibiotic Resistance Genes"
                            icon={icon4}
                            number={statData ? statData.resistance : ''}
                            linkTo="resistance"
                            linkText="Overview"/>
                    </div>}
                </div>}
                {dataStatus === 'Success' && <hr/>}
                {dataStatus === 'Success' && <div className="map-wrapper row">
                    <div className="col">
                        <h2>Collection location</h2>
                        <div className="map">
                            <Map style={{height: 400}}/>
                        </div>
                    </div>
                </div>}
                {dataStatus === 'Success' && <hr/>}
                {(dataStatus === 'Success' && statData.phylotree > 0) && <div className="strain-phylo row">
                    <div className="col">
                        <h2>Strain Phylogeny</h2>
                        <div>
                            <StrainPhylotree id='full_tree' />
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    );
}
